import { defineStore, acceptHMRUpdate } from 'pinia'
import axios from 'axios'

export const useCardsStore = defineStore('cards', {
    state: () => ({
        initialized: false,
        active_cards: [],
        has_had_product_areas: []
    }),
    actions: {
        getCards () {
            axios.get('/cards')
                .then(response => {
                    console.log('getCards complete')
                    console.log(response.data)

                    this.initialized = true
                    this.active_cards = response.data.active_cards
                    this.has_had_product_areas = response.data.has_had_product_areas
                })
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCardsStore, import.meta.hot))
}
